import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './fornecedorActions';

class FornecedorForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						{!this.props.formularioValues.id &&
						<Row>
							<Field
								name='tipo_pessoa'
								options={[{ id: 'fisica', valor: 'Pessoa Física' }, { id: 'juridica', valor: 'Pessoa Jurídica' }]}
								component={Select}
								label='Tipo' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly}
								value={this.props.formularioValues.tipo_pessoa}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										tipo_pessoa: value,
										nome_fantasia: null,
										razao_social: null,
										cnpj: null,
										cpf: null,
										rg: null
									})
								}} />
						</Row>}

						<Row>
							{this.props.formularioValues.tipo_pessoa == 'juridica' &&
							<Field
								name='razao_social'
								component={LabelAndInput}
								label='Razão Social *' placeholder='Informe'
								cols='12 5 5 5'
								readOnly={readOnly} />}
							
							{this.props.formularioValues.tipo_pessoa == 'juridica' &&
							<Field
								name='nome_fantasia'
								component={LabelAndInput}
								label='Nome Fantasia *' placeholder='Informe'
								cols='12 5 5 5'
								readOnly={readOnly} />}
							
							{this.props.formularioValues.tipo_pessoa == 'fisica' &&
							<Field
								name='razao_social'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 5 5 5'
								readOnly={readOnly} />}

							<Field
								name='codigo_integracao'
								component={LabelAndInput}
								label='Código de Integração' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							{this.props.formularioValues.tipo_pessoa == 'juridica' &&
							<Field
								name='cnpj'
								component={LabelAndInputMask}
								label='CNPJ *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={220}
								readOnly={readOnly}
								mask='99.999.999/9999-99' />}
							
							{this.props.formularioValues.tipo_pessoa == 'fisica' &&
							<Field
								name='cpf'
								component={LabelAndInputMask}
								label='CPF *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								mask='999.999.999-99' />}
													
							<Field
								name='ie'
								component={LabelAndInput}
								label='Inscrição Estadual' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly} />
						</Row>
						<Row>							
							<Field
								name='endereco'
								component={LabelAndInput}
								label='Endereço' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly} />
							
							<Field
								name='numero'
								component={LabelAndInput}
								label='Número' placeholder='Informe'
								cols='12 3 2 2'
								readOnly={readOnly} />
							
							<Field
								name='complemento'
								component={LabelAndInput}
								label='Complemento' placeholder='Informe'
								cols='12 3 3 3'
								readOnly={readOnly} />
						</Row>
						<Row>							
							<Field
								name='bairro'
								component={LabelAndInput}
								label='Bairro' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly} />
							
							<Field
								name='cep'
								component={LabelAndInputMask}
								label='CEP' placeholder='Informe'
								cols='12 4 2 2'
								readOnly={readOnly}
								mask='99999-999' />
								
							<Field
								name='id_cidade'
								options={this.props.listaCidade}
								component={Select}
								label='Cidade' placeholder='Informe'
								cols='12 12 7 7'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='telegram'
								component={LabelAndInputMask}
								label='Telegram' placeholder='Informe'
								cols='12 4 3 2'
								readOnly={readOnly}
								mask='(99) 9 9999-9999' />
							
							<Field
								name='whatsapp'
								component={LabelAndInputMask}
								label='Whatsapp' placeholder='Informe'
								cols='12 4 3 2'
								readOnly={readOnly}
								mask='(99) 9 9999-9999' />
							
							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

FornecedorForm = reduxForm({form: 'fornecedorForm', destroyOnUnmount: false})(FornecedorForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('fornecedorForm')(state),
	registro: state.fornecedor.registro,
	listaCidade: state.fornecedor.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FornecedorForm);
